import mock from './mock'
import './pages/account-settings'
//import './pages/profile'
import './jwt'
import './materials'
import './impact'
import './partners'
import './routes'

mock.onAny().passThrough()